<template>
  <footer class="footer">
    <div class="inner">
      <div class="page-nav">
        <ul class="list">
          <li>
            <router-link to="./" class="link-over">TOP</router-link>
          </li>
          <li>
            <router-link to="#" class="link-over">{{ title }}</router-link>
          </li>
        </ul>
      </div>
      <div class="language">
        <div class="logo sp-only">
          <img src="../assets/img/logo-img.svg" alt="Logo" />
        </div>
        <div class="select-box" v-on:click="active">
          <p class="japanese" v-if="$i18n.locale !== 'en'">
            {{ $t("JAPANESE") }}
          </p>
          <p class="english" v-if="$i18n.locale !== 'ja'">
            {{ $t("ENGLISH") }}
          </p>
          <div class="select" v-if="isActive">
            <div
              class="option japanese"
              v-on:click.prevent="ChangeLanguage('ja')"
            >
              {{ $t("JAPANESE") }}
            </div>
            <div
              class="option english"
              v-on:click.prevent="ChangeLanguage('en')"
            >
              {{ $t("ENGLISH") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul class="footer-fixed-menu">
      <li>
        <router-link to="./" class="link-over">
          <div class="img">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect
                    id="長方形_416"
                    data-name="長方形 416"
                    width="24"
                    height="24"
                    transform="translate(26 1162)"
                    fill="#fff"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </clipPath>
              </defs>
              <g
                id="マスクグループ_54"
                data-name="マスクグループ 54"
                transform="translate(-26 -1162)"
                clip-path="url(#clip-path)"
              >
                <g
                  id="レイヤー_2"
                  data-name="レイヤー 2"
                  transform="translate(26 1162.34)"
                >
                  <g id="_1" data-name=" 1">
                    <path
                      id="パス_224"
                      data-name="パス 224"
                      d="M12,18.85,9.037,17.393,12,23.32l2.964-5.927Z"
                      fill="#fff"
                    />
                    <path
                      id="パス_225"
                      data-name="パス 225"
                      d="M19.825,0H4.175A4.187,4.187,0,0,0,0,4.175v10.5A4.187,4.187,0,0,0,4.175,18.85H19.825A4.187,4.187,0,0,0,24,14.676V4.175A4.187,4.187,0,0,0,19.825,0ZM17.448,14.406a.816.816,0,0,1-.813.813H13.73V12.542H10.271v2.677h-2.9a.816.816,0,0,1-.815-.813V12.644L12,7.654l5.448,4.99Zm.9-4.5A1.208,1.208,0,0,1,16.641,10L12,5.833,7.359,10A1.208,1.208,0,1,1,5.746,8.2L12,2.587,18.255,8.2a1.207,1.207,0,0,1,.092,1.707Z"
                      fill="#fff"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <p>{{ $t("My Wallet") }}</p>
        </router-link>
      </li>
      <li>
        <router-link to="./organizationchart" class="link-over">
          <div class="img">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect
                    id="長方形_416"
                    data-name="長方形 416"
                    width="24"
                    height="24"
                    transform="translate(26 1162)"
                    fill="#fff"
                    stroke="#707070"
                    stroke-width="1"
                  />
                </clipPath>
              </defs>
              <g
                id="マスクグループ_52"
                data-name="マスクグループ 52"
                transform="translate(-26 -1162)"
                clip-path="url(#clip-path)"
              >
                <g
                  id="レイヤー_2"
                  data-name="レイヤー 2"
                  transform="translate(28.372 1162.012)"
                >
                  <g id="_1" data-name=" 1">
                    <path
                      id="パス_223"
                      data-name="パス 223"
                      d="M13.74,17.586a3.178,3.178,0,0,0-1.183.226L9.1,14.517a4.854,4.854,0,0,0,0-4.861l5.769-3.48a3.207,3.207,0,1,0-1.794-1.794L7.306,7.862a4.877,4.877,0,1,0,0,8.449L10.763,19.6a3.2,3.2,0,1,0,2.976-2.022Z"
                      fill="#fff"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <p>{{ $t("Organization") }}</p>
        </router-link>
      </li>
      <li>
        <router-link to="./plan" class="link-over">
          <div class="img">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect
                    id="長方形_416"
                    data-name="長方形 416"
                    width="24"
                    height="24"
                    transform="translate(26 1162)"
                    fill="#fff"
                    stroke="#707070"
                    stroke-width="1"
                  />
                </clipPath>
              </defs>
              <g
                id="マスクグループ_53"
                data-name="マスクグループ 53"
                transform="translate(-26 -1162)"
                clip-path="url(#clip-path)"
              >
                <g
                  id="レイヤー_2"
                  data-name="レイヤー 2"
                  transform="translate(26 1162.187)"
                >
                  <g id="_1" data-name=" 1">
                    <rect
                      id="長方形_417"
                      data-name="長方形 417"
                      width="6"
                      height="5.25"
                      rx="1.5"
                      transform="translate(0 18.375)"
                      fill="#fff"
                    />
                    <rect
                      id="長方形_418"
                      data-name="長方形 418"
                      width="6"
                      height="5.25"
                      rx="1.5"
                      transform="translate(0 9)"
                      fill="#fff"
                    />
                    <rect
                      id="長方形_419"
                      data-name="長方形 419"
                      width="6"
                      height="5.25"
                      rx="1.5"
                      fill="#fff"
                    />
                    <rect
                      id="長方形_420"
                      data-name="長方形 420"
                      width="12.75"
                      height="5.25"
                      rx="1.5"
                      transform="translate(11.25 9)"
                      fill="#fff"
                    />
                    <rect
                      id="長方形_421"
                      data-name="長方形 421"
                      width="12.75"
                      height="5.25"
                      rx="1.5"
                      transform="translate(11.25)"
                      fill="#fff"
                    />
                    <rect
                      id="長方形_422"
                      data-name="長方形 422"
                      width="12.75"
                      height="5.25"
                      rx="1.5"
                      transform="translate(11.25 18.375)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <p>{{ $t("PLAN") }}</p>
        </router-link>
      </li>
      <li>
        <router-link to="./account" class="link-over">
          <div class="img">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect
                    id="長方形_416"
                    data-name="長方形 416"
                    width="24"
                    height="24"
                    transform="translate(26 1162)"
                    fill="#fff"
                    stroke="#707070"
                    stroke-width="1"
                  />
                </clipPath>
              </defs>
              <g
                id="マスクグループ_51"
                data-name="マスクグループ 51"
                transform="translate(-26 -1162)"
                clip-path="url(#clip-path)"
              >
                <g
                  id="レイヤー_2"
                  data-name="レイヤー 2"
                  transform="translate(31.068 1164.168)"
                >
                  <g id="_1" data-name=" 1">
                    <circle
                      id="楕円形_15"
                      data-name="楕円形 15"
                      cx="5.234"
                      cy="5.234"
                      r="5.234"
                      transform="translate(-0.469 5.233) rotate(-45)"
                      fill="#fff"
                    />
                    <path
                      id="パス_222"
                      data-name="パス 222"
                      d="M13.864,13.912A17.007,17.007,0,0,0,0,13.912v7.92H13.864Z"
                      fill="#fff"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <p>{{ $t("ACCOUNT") }}</p>
        </router-link>
      </li>
    </ul>
    <div class="ani-txt-bar" style="display: none">
      <p>
        ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO
        DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION
        PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT
        ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO
        DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION
        PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT
        ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO
        DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION
        PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT
        ALEPHZERO DIFFUSION PROJECT ALEPHZERO DIFFUSION PROJECT ALEPHZERO
        DIFFUSION PROJECT
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: ["title"],
  data: () => {
    return {
      isActive: false,
    };
  },
  methods: {
    ChangeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    active: function () {
      this.isActive = !this.isActive;
    },
  },
};
</script>

<style scoped lang="less"></style>
